module.exports = __webpack_public_path__ + "static/media/taxPlan-service-img.97c50da1.png";